import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import useJarallax from 'hooks/useJarallax';

import Mission from './Mission';
import Vision from './Vision';
import Purpose from './Purpose';
import Values from './Values';

import purposeBG from 'assets/images/backgrounds/bg_purpose.jpg';
import visionBG from 'assets/images/backgrounds/bg_vision.jpg';
import missionBG from 'assets/images/backgrounds/bg_mission.jpg';
import valuesBG from 'assets/images/backgrounds/bg_values.jpg';
import { SimSlider, SimSliderItem } from 'components/SimSlider';

const AboutSlider = () => {
	const theme = useTheme();
	useJarallax();

	const ImageStyles = bgImage => ({
		position: 'absolute',
		objectFit: 'fill',
		fontFamily: 'object-fit: cover;',
		top: 0,
		left: 0,
		width: 'auto',
		height: '100%',
		zIndex: -1,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'auto 120% ',
		backgroundPosition: 'center center',
		backgroundImage: `url(${bgImage})`,
		filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none'
	});

	return (
		<Box>
			<Box
				bgcolor={'transparent'}
				height={{ xs: '100vh', sm: '90vh', md: '90vh', lg: '90vh' }}
				backgroundColor={'none'}>
				<Box
					backgroundColor={'none'}
					height={{ xs: '100vh', sm: '90vh', md: '90vh', lg: '90vh' }}
					sx={{
						height: { xs: 'auto', md: 1 },
						'& .slick-slide img': {
							objectFit: 'cover'
						},
						'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
							height: { xs: 'auto', md: 1 }
						},
						'& .slick-prev, & .slick-next': {
							zIndex: 2,
							bottom: 0,
							top: '100%',
							left: '100%',
							right: 0,
							transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
							marginLeft: theme.spacing(-2),
							width: 32,
							height: 32,
							'&:before': {
								fontSize: 32,
								color: alpha(theme.palette.primary.main, 0.5)
							}
						},
						'& .slick-prev': {
							marginLeft: theme.spacing(-7)
						}
					}}>
					<SimSlider
						options={{
							dots: false,
							speed: 500,
							slidesToShow: 1,
							autoplay: false,
							autoplaySpeed: 3000
						}}>
						<SimSliderItem sx={ImageStyles(purposeBG)}>
							<Purpose />
						</SimSliderItem>
						<SimSliderItem sx={ImageStyles(missionBG)}>
							<Mission />
						</SimSliderItem>
						<SimSliderItem sx={ImageStyles(visionBG)}>
							<Vision />
						</SimSliderItem>
						<SimSliderItem sx={ImageStyles(valuesBG)}>
							<Values />
						</SimSliderItem>
					</SimSlider>
				</Box>
			</Box>
		</Box>
	);
};

export { AboutSlider };
